import React, { useEffect } from 'react';

import { ChainedRender } from 'Modules/core/react';
import { useAction } from 'Modules/core/redux';

import { configActions } from './state/actions';


export const ConfigModule: ChainedRender = ({ Next }) => {
    const getConfig = useAction(configActions.get, []);
    useEffect(
        () => {
            getConfig();
        },
        [getConfig],
    );

    return <Next />;
};
